import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Translate } from "react-thunk-i18nify";
import Select from "react-select";

import { monthsInAYearOptions } from "constants/dropdownOptions";

import { formatDropdownOptions } from "utils/utils";

const YearMonthFilter = ({
  cellPhoneNumber,
  fetchSubscriptionUsageReportData,
  isSubscriptionUsageFetching,
}) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const [selectedYearMonths, setSelectedYearMonths] = useState();
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState();

  const filterAndSetSelectedYearMonths = (filteredYear) => {
    if (parseInt(filteredYear, 10) !== currentYear) {
      setSelectedYearMonths(monthsInAYearOptions);

      return;
    }

    const monthsTillCurrentOne = monthsInAYearOptions.filter(
      ({ value }) => parseInt(value, 10) <= parseInt(currentMonth, 10)
    );

    setSelectedYearMonths(monthsTillCurrentOne);

    if (selectedMonth && !monthsTillCurrentOne.includes(selectedMonth))
      setSelectedMonth({});
  };

  useEffect(() => {
    setSelectedYear({
      label: String(currentYear),
      value: String(currentYear),
    });

    setSelectedMonth({
      label: monthsInAYearOptions.find(
        (month) => parseInt(month.value, 10) === currentMonth
      ).label,
      value: currentMonth,
    });

    filterAndSetSelectedYearMonths(currentYear);
  }, [cellPhoneNumber]);

  useEffect(() => {
    if (isSubscriptionUsageFetching) return;

    if (!selectedYear || !selectedMonth?.value) return;

    if (
      parseInt(selectedYear.value, 10) === currentYear &&
      parseInt(selectedMonth.value, 10) > currentMonth
    ) {
      return;
    }

    fetchSubscriptionUsageReportData(
      `${selectedYear.value}-${selectedMonth.value}`
    );
  }, [selectedYear, selectedMonth]);

  const getUsageReportYears = () => {
    const minimumYear = 2021;
    const usageReportYears = [];

    for (let year = minimumYear; year <= currentYear; year += 1) {
      usageReportYears.push(String(year));
    }

    return usageReportYears;
  };

  const handleYearSelect = (yearFromFilter) => {
    filterAndSetSelectedYearMonths(yearFromFilter.value);

    setSelectedYear(yearFromFilter);
  };

  const handleMonthSelect = (monthFromFilter) => {
    if (monthFromFilter === selectedMonth) {
      return;
    }

    setSelectedMonth(monthFromFilter);
  };

  return (
    <div className="d-flex align-items-center">
      <span className="me-2 fw-bold text-muted">
        <Translate value="common.filter" />
      </span>

      <Select
        className="pl-0 me-2"
        options={formatDropdownOptions(getUsageReportYears())}
        onChange={handleYearSelect}
        value={selectedYear}
        placeholderTranslation="common.chooseYear"
        isLoading={isSubscriptionUsageFetching}
      />

      <Select
        className="pl-0"
        options={selectedYearMonths}
        onChange={handleMonthSelect}
        value={selectedMonth}
        placeholderTranslation="common.chooseYear"
        isLoading={isSubscriptionUsageFetching}
      />
    </div>
  );
};

YearMonthFilter.defaultProps = {};

YearMonthFilter.propTypes = {
  cellPhoneNumber: PropTypes.string.isRequired,
  fetchSubscriptionUsageReportData: PropTypes.func.isRequired,
  isSubscriptionUsageFetching: PropTypes.bool.isRequired,
};

export default YearMonthFilter;
